import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectIsAuthenticated, selectIsAuthChecked, selectUser } from "../store/slices/userSlice";
import Loader from "./Loader";

export default function ProtectedRoute() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAuthChecked = useSelector(selectIsAuthChecked);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);
  const accessDenied = isAuthChecked && isAuthenticated && (user?.role !== "admin" || user?.active === false || user?.active === null);

  useEffect(() => {
    if (accessDenied) dispatch(logout());
  }, [dispatch, accessDenied]);

  // While auth is being checked, show loading
  if (!isAuthChecked) return <Loader />;

  // If not authenticated, redirect to login
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  if (accessDenied) return <Navigate to="/login" replace state={{ from: location }} />;

  // Otherwise, render children
  return <Outlet />;
}
